
interface TestimonialsHeroProps {
  title?: string;
  subtitle?: string;
}

export const TestimonialsHero = ({
  title = "",
  subtitle = "",
}: TestimonialsHeroProps) => {

  return (
    <section className="py-24 md:py-32">
      <div className="mx-auto max-w-4xl px-4 text-center md:px-8">
        <h1 className="font-display text-5xl font-normal leading-tight text-fg-primary md:text-6xl lg:text-7xl">
          {title}
        </h1>
        
        {subtitle && (
          <p className="mt-6 font-display text-lg leading-relaxed text-tertiary md:text-xl max-w-3xl mx-auto">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

import { registerThemeVariant } from '../../lib/component-registry';
registerThemeVariant('hero-testimonials', 'aman', TestimonialsHero);
